import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@redux/hooks';
import { Task } from '@models/task.model';
import { crewService } from '@services/crew';

/**
 * Prefix key. Assignment mutations invalidate with this, which prefix-matches
 * every filter combination cached below.
 */
export const ASSIGNABLE_TASKS_QUERY_KEY = ['assignableTasks'];

type Options = {
  /** Empty or undefined means every project in the organization. */
  projectIds?: string[];
  includeCompleted?: boolean;
  enabled?: boolean;
};

export const useAssignableTasks = ({
  projectIds,
  includeCompleted = false,
  enabled = true,
}: Options = {}) => {
  const organizationId = useAppSelector(
    (state) => state.organization.organizationId,
  );

  // Sorted so two callers asking for the same projects in a different order
  // share one cache entry instead of refetching.
  const projectKey = [...(projectIds ?? [])].sort().join(',');

  return useQuery<Task[], Error>({
    queryKey: [
      ...ASSIGNABLE_TASKS_QUERY_KEY,
      organizationId,
      projectKey,
      includeCompleted,
    ],
    enabled,
    queryFn: async () =>
      (await crewService.getAssignableTasks(projectIds, includeCompleted)) || [],
  });
};

export default useAssignableTasks;
